import { Helmet } from 'react-helmet';
import { useKeycloak } from 'src/components/AuthHOC';
import IOPPUserAccount from './IOPPUserMyProfile';
import UserProfile from 'src/components/User/UserProfile';

const Account = () => {
  const { currentUser } = useKeycloak();

  return (
    <>
      <Helmet>
        <title>My Account</title>
      </Helmet>
      {currentUser.idp === "ioppublishing" ?
        <IOPPUserAccount />
        :
        <UserProfile />
      }
    </>
  );
};

export default Account;
